angular
    .module('empower.lodgeClaimACTG')
    .constant('lodgeClaimACTGWording', {
        EMAIL_NOT_EXISTED: 'Please provide your email address to save the claim informtaion.',
        LODGE_CLAIM_SUCCESS:'Thank you for completing your claim form.<br/>Your reference number is <strong>{{IncidentNumber}}</strong>.<br/>One of our case managers will be in contact with you shortly to help with your claim.', 
        PROCESS_SAVED:'Your form has been saved to complete later.<br/>Your reference number is <strong>{{IncidentNumber}}</strong>.<br/>You will shortly receive a confirmation email to the address you have provided. Thank you.', 
        INCIDENT_NUMBER_NOT_EXISTED: 'This incident number does not exist.',
        GET_INCIDENT_NUMBER_SUCCESSFULLY: 'Your form has been loaded successfully.',
        GET_INCIDENT_NUMBER_FINISHED: 'This form has already been submitted and no changes can be made.<br/>If you need to speak to us, you can get in touch on our toll free number - 1800 EML CBR (365 227).',
        VALIDATION_MEDICAL_FORM_EXIST: 'A medical certificate has already been attached. You will need to remove it to replace it with an updated form.',
        VALIDATION_MEDICAL_FORM_REQUIRED: 'A medical certificate is required.',
        FORM_INVALID: 'All mandatory fields must be filled',
        DATE_INVALID: 'Date field(s) is invalid',
        MEDICAL_FORM: 'MEDICAL_FORM',
        ADDITIONAL_DOCUMENT: 'ADDITIONAL_DOCUMENT',
        REQUIRED: 'is required',
        INVALID_DATE: 'is not a correct date',
        INVALID_MIN_DATE: 'must be after Injury Date',
        INVALID_MAX_DATE: 'must not be after today',
        INVALIDFORMAT: 'is invalid',
        // EMAIL: 'is not a valid email',
        // MASK: 'has invalid format.',
        EMPLOYEEDATEOFBIRTH: "Date of Birth",
        INJURYDATE: 'Injury Date',
        REPORTEDDATE: 'Date Reported',
        FIRSTNOTICEDATE: 'First Notice Date',
        DATESTOPPEDWORK: 'Date Stopped Work',
        RETURNEDTOWORKDATE: 'Date Returned',
        FIRSTSEEKDATE: 'First Treatement Date',
        MEDICAL_REQUIRED: 'is required',
        MEDICALUPLOAD: 'Medical certificate',
        EMPLOYEEEMAILADDRESS: 'Employee email address',
        MANAGEREMAILADDRESS: 'Manager email address',
        EMPLOYEEHOMEPHONE: 'Home number',
        EMPLOYEEWORKPHONE: 'Work number',
        EMPLOYEEMOBILEPHONE: 'Mobile number',
        WITNESSPHONENUMBER: 'Witness phone number',
        PRACTITIONERFAX: 'Practitioner Fax',
        PRACTITIONERPHONENUMBER: 'Practitioner phone number',
    });

